import { Link } from "react-router-dom";
import { Trophy, Key } from "@phosphor-icons/react";
import { GAMES } from "@/lib/games";

const CARDS = [
  { to: "/admin/results", label: "Manage Results", desc: "Publish, edit or unpublish today's FR/SR", icon: Trophy, color: "bg-red-600" },
  { to: "/admin/change-password", label: "Change Password", desc: "Rotate your admin password", icon: Key, color: "bg-neutral-900" },
];

export default function AdminDashboard() {
  return (
    <div>
      <h1 className="font-heading font-black text-3xl">Dashboard</h1>
      <p className="text-neutral-600 text-sm mt-1">
        Managing all {GAMES.length} Teer results from one central console. Publishing a result auto-updates the
        homepage, the Teer page, previous results and common numbers.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
        {CARDS.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="bg-white rounded-2xl p-5 border border-neutral-200 flex items-start gap-4 hover:shadow-md transition"
            data-testid={`dash-${c.label.toLowerCase().replace(/\s/g, "-")}`}
          >
            <div className={`w-11 h-11 rounded-xl ${c.color} text-white flex items-center justify-center`}>
              <c.icon size={22} weight="bold" />
            </div>
            <div>
              <div className="font-heading font-bold text-lg">{c.label}</div>
              <div className="text-sm text-neutral-600">{c.desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
